import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { HighlightTextWebElement } from './HighlightTextWebElement';
export { HighlightTextWebElement };

/**
 * Retrieve an instance of [HighlightTextWebElement](../classes/HighlightTextWebElement.html).
 * @example
 * ```javascript
 * import { findHighlightText } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findHighlightText(driver, By.id('my-oj-c-highlight-text'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findHighlightText(
  driver: DriverLike,
  by: By
): Promise<HighlightTextWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type HighlightTextWebElement
  if (!(webEl instanceof HighlightTextWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'HighlightTextWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findHighlightText(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${HighlightTextWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-highlight-text', HighlightTextWebElement);
